export default function () {
    return {
        init() {
            this.setupWatchers();
        },

        setupWatchers() {
            this.$watch('activeMobileNavElement', () => {
                if (this.activeMobileNavElement === this.navElements.account) {
                    const accountUrl = document
                        .querySelector('.action.account')
                        .getAttribute('href');

                    window.location = accountUrl;
                }
            });
        }
    };
}
